import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://99b69933a615bb0395150c9b9465feea@o4509197598457856.ingest.us.sentry.io/4509531701706753"
});

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

import { Provider } from 'react-redux';
import store from './redux/store';

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
let payload = urlParams.get('id_token');
let shopUrl = urlParams.get('shop');

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <App payload={payload} shopUrl={shopUrl}/>
    </Provider>
  </React.StrictMode>,
)
